import * as EventLogsActions from './event-logs.actions';

export default EventLogsActions;
